// extracted by css-extract-rspack-plugin
export default {"container":"SubscriptionSection-module__container__oxt9kDu","button":"SubscriptionSection-module__button__KWQsZB0","header":"SubscriptionSection-module__header__BHiMpVt"};